import { render, staticRenderFns } from "./ServicesTemplate.vue?vue&type=template&id=16fd639e&"
import script from "./ServicesTemplate.vue?vue&type=script&lang=js&"
export * from "./ServicesTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ServicesTemplate.vue?vue&type=style&index=0&id=16fd639e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports